<script>
export default {
  name: "render-file",
  props: {
    fileType: {
      type: String,
      default: 'img'
    },
    url: {
      type: String,
      default: ''
    }
  },

  computed: {
    // 节点原生属性
    mainProperty() {
      const fileProperty = {
        image: {alt: 'banner'},
        video: {loop: true, controls: true, autoplay: true, muted: true}
      }
      return fileProperty[this.fileType] || {}
    },

    // 节点名
    element() {
      const map = new Map([['image', 'img'], ['video', 'video']])
      return map.get(this.fileType)
    }
  },

  render(createElement) {
    return createElement(this.element, {
      attrs: {
        class: `${this.fileType}-file`,
        src: this.url,
        ...this.mainProperty
      },
    })
  }

}
</script>

<style lang="scss" scoped>
  .image-file {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video-file {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
